import React, { useMemo, useState } from "react";
import styles from "./scss/OneClickCancellation.module.scss";
import OneClickCancellationModal from "./components/OneClickCancellationModal";
import OneClickCancellationSelectedClinics from "./components/OneClickCancellationSelectedClinics";
import { useClinicsLoyaltyList } from "./hooks/useClinicsLoyaltyList";

const OneClickCancellation = () => {
  const [showModal, setShowModal] = useState(false);

  const { data } = useClinicsLoyaltyList();

  const activeClinics = useMemo(
    () => data?.filter((clinic) => clinic.canPatientCancel),
    [data],
  );

  return (
    <>
      <div className={styles.container}>
        <>
          <span>Allow 1 Click Cancellation on Patient Portal</span>
        </>
      </div>
      {showModal && (
        <OneClickCancellationModal
          activeClinics={activeClinics}
          onClose={() => setShowModal(false)}
        />
      )}
      <OneClickCancellationSelectedClinics
        setShowModal={setShowModal}
        activeClinics={activeClinics}
      />
    </>
  );
};

export default OneClickCancellation;
